/**
 * JeriCommerce Pass API · staging
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SegmentDto { 
    id: string;
    programIntegrationId: string;
    name: string;
    externalId?: string;
    source: SegmentDto.SourceEnum;
    systemKey?: string;
    category?: SegmentDto.CategoryEnum;
    status: SegmentDto.StatusEnum;
    sortOrder: number;
    createdAt: string;
    updatedAt: string;
    integrationId: string;
    readOnly: boolean;
    /**
     * Rule description for internal segments; null for external ones.
     */
    description?: string;
}
export namespace SegmentDto {
    export const SourceEnum = {
        External: 'external',
        Internal: 'internal'
    } as const;
    export type SourceEnum = typeof SourceEnum[keyof typeof SourceEnum];
    export const CategoryEnum = {
        Tiers: 'tiers',
        Onboarding: 'onboarding',
        Engagement: 'engagement',
        PurchaseLevel: 'purchase_level',
        PurchaseActivity: 'purchase_activity',
        StoreActivity: 'store_activity',
        LoyaltyBalance: 'loyalty_balance'
    } as const;
    export type CategoryEnum = typeof CategoryEnum[keyof typeof CategoryEnum];
    export const StatusEnum = {
        Building: 'building',
        Ready: 'ready',
        Error: 'error'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


